import React, { useState } from 'react';
import exitBtnImg from "../../assets/common_imgs/exit_btn.png"
import resultCards from '../../code/js/games/non_timer/funCard/UI/resultCards';
import "../OptionsMenuholdem/OptionsMenuholdem.scss"
const OptionsMenu = ({ minBetAmt, maxBetAmt, GameRules, tableProps, tableclass, headClass, bodyClass, history, openOptions = () => { } }) => {

    const [showDivs, setShowDivs] = useState({
        ShowLimits: false,
        ShowGamerules: false,
        ShowHistory: true
    })

    // console.log(showDivs.ShowLimits)
    // console.log(showDivs.ShowGamerules)
    // console.log(showDivs.ShowHistory)

    return <div className="back_coverholdem">
        <div id="allOptionsholdem">
            <div className="outerBevelholdem">
                <div className="flatSurfaceholdem">
                    <div className="innerBevelholdem">
                        <div id="options_contentholdem">
                            {/* <img src={exitBtnImg} id="options_exit_btn" alt="exitBtn" onClick={openOptions} /> */}
                            <div id="options_exit_btnholdem" alt="exitBtn" onClick={openOptions}>X</div>
                            <div id="btnGroupholdem">
                                <button className={`optionsBtnhldm ${showDivs.ShowHistory && "opt_btn_activeholdem"}`} role="button" onClick={(e) => { e.preventDefault(); setShowDivs({ ShowLimits: false, ShowGamerules: false, ShowHistory: true }); }}>History</button>
        
                                <button className={`optionsBtnhldm ${showDivs.ShowGamerules && "opt_btn_activeholdem"}`} role="button" onClick={(e) => { e.preventDefault(); setShowDivs({ ShowLimits: false, ShowGamerules: true, ShowHistory: false }); }}>Help</button>
                        <button className={`optionsBtnhldm ${showDivs.ShowLimits && "opt_btn_activeholdem"}`} role="button" onClick={(e) => { e.preventDefault(); setShowDivs({ ShowLimits: true, ShowGamerules: false, ShowHistory: false }); }}>Limits</button>
                            </div>
                            <div id="opt_contentholdem">
                                <div id="Limits12holdem" className={`section ${showDivs.ShowLimits ? "visible" : "hidden"}`}>
                                    <span>MinBet: {minBetAmt}</span>
                                    <span>MaxBet: {maxBetAmt}</span>
                                </div>
                                {/* {
                                    showDivs.ShowGamerules && <div id="GameRules">
                                        <h1 id="gameruleMainHeading">GAME RULES</h1>
                                        <ul id="unorderedlistitems">

                                            <hr id="hrline" />
                                            {GameRules.map((val, key) => (
                                                <li>{val.name}</li>

                                          
                                        </ul>
                                        {val.button && <div>{val.button}</div>}
                                        <p>{val.name}</p>
                                          ))}
                                    </div>
                                } */}
                                <div id="GameRulesholdem" className={`section ${showDivs.ShowGamerules ? "visible" : "hidden"}`}>
                                    <h1 id="gameruleMainHeadingholdem">GAME RULES</h1>
                                    <hr id="hrlineholdem" />
                                    <ul id="unorderedlistitemsholdem">
                                        {/* {GameRules.map((val, key) => (
                                                <li key={key}>
                                                    <div className="rule-line">
                                                        {val.button && <span className="button-wrap">{val.button}</span>}
                                                        <span className="rule-text">{val.name}</span>
                                                    </div>
                                                </li>

                                            ))} */}
                                        <li>
                                            {GameRules.map((rule, index) => {
                                                const isAnteBetLine = index == 6 || index == 16;

                                                return (
                                                    <div
                                                        key={index}
                                                        id={isAnteBetLine ? 'antebet_holdemcombination' : ""}
                                                        style={{
                                                            marginBottom: '20px',
                                                            ...(isAnteBetLine && {
                                                                color: '#8cf35c6b',
                                                                fontSize: '40px'
                                                            })
                                                        }}
                                                    >
                                                        {/* <p>{rule.name}</p> */}
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                                            {rule.element && rule.element}
                                                            {rule.button && rule.button}
                                                            <p id="Holdemgame_rules" style={{ margin: 0 }}>{rule.name}</p>

                                                        </div>


                                                        {/* {rule.element && rule.element} */}

                                                    </div>
                                                );
                                            })}
                                        </li>


                                    </ul>
                                </div>

                                {history.length > 0 ? (
                                    <table id={tableclass} className={`section ${showDivs.ShowHistory ? "visible" : "hidden"}`} style={{ borderCollapse: "collapse", width: "114%" }}>
                                        <thead>
                                            <tr id="holdem-main">
                                                {tableProps.filter(ele => ele.isdisplay).map((ele, ind) => {
                                                    if (ele.key === "anteBetAmount" || ele.key === "bonusBet" || ele.key === "call") {
                                                        // Ante and Bonus with two subtitles (wager, win)
                                                        return (
                                                            <th
                                                                key={ind}
                                                                colSpan={2}
                                                                style={{ border: "3px solid #ddd", padding: "8px", textAlign: "center" }}
                                                            >
                                                                {ele.title}
                                                            </th>
                                                        );
                                                    } 
                                                    else {
                                                        return (
                                                            <th
                                                                key={ind}
                                                                rowSpan={2}
                                                                style={{ border: "3px solid #ddd", padding: "8px", textAlign: "center" }}
                                                            >
                                                                {ele.title}
                                                            </th>
                                                        );
                                                    }
                                                })}
                                            </tr>
                                            <tr id="holdem-sub">
                                                {tableProps.filter(ele => ele.isdisplay).map((ele, ind) => {
                                                    if (ele.key === "anteBetAmount" || ele.key === "bonusBet" || ele.key === "call") {
                                                        return (
                                                            <>
                                                                <th
                                                                    key={`${ind}-wager`}
                                                                    style={{ border: "3px solid #ddd", padding: "6px", textAlign: "center", fontWeight: "normal" }}
                                                                >
                                                                    Wager
                                                                </th>
                                                                <th
                                                                    key={`${ind}-win`}
                                                                    style={{ border: "3px solid #ddd", padding: "6px", textAlign: "center", fontWeight: "normal" }}
                                                                >
                                                                    Win
                                                                </th>
                                                            </>
                                                        );
                                                    }
                                                    return null;
                                                })}
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {history.filter((obj, i, arr) => arr.length - i <= 5).map((obj, i) => (
                                                <tr key={`card-${i}`} id={`${i}`} style={{ borderBottom: "1px solid #eee" }}>
                                                    {tableProps.filter(ele => ele.isdisplay).map((ele, ind) => {

                                                        let wager = "-";
                                                        let win = "-";
                                                        if (ele.key === "anteBetAmount" || ele.key === "bonusBet" || ele.key === "call") {

                                                            if (ele.key === "anteBetAmount") {
                                                                wager = obj.result?.anteBetAmount ?? 0;
                                                                win = obj.result?.anteWin ?? 0;
                                                            }
                                                            if (ele.key === "bonusBet") {
                                                                wager = obj.result?.bonusBet ?? 0;
                                                                win = obj.result?.bonusWinAmount ?? 0;
                                                            }
                                                            if (ele.key === "call") {
                                                                wager = obj.result?.betAmount ?? 0;
                                                                win = obj.result?.winAmount ?? 0;
                                                            }

                                                            return (
                                                                <>
                                                                    <td
                                                                        key={`${ind}-wager`}
                                                                        style={{ border: "3px solid #ddd", padding: "8px", textAlign: "center" }}
                                                                    >
                                                                        {wager}
                                                                    </td>
                                                                    <td
                                                                        key={`${ind}-win`}
                                                                        style={{ border: "3px solid #ddd", padding: "8px", textAlign: "center" }}
                                                                    >
                                                                        {win}
                                                                    </td>
                                                                </>
                                                            );
                                                        } else if (ele.isShowCards) {
                                                            return (
                                                                <td
                                                                    key={ind}
                                                                    style={{ border: "3px solid #ddd", padding: "8px", textAlign: "center" }}
                                                                >
                                                                    {obj.result[ele.key]?.map((card_num, index) => {
                                                                        const matchingCard = resultCards.find(res => res.rsc_val === card_num);
                                                                        return (
                                                                            <img
                                                                                className="cardsimagesholdem"
                                                                                key={index}
                                                                                src={matchingCard ? matchingCard.src : ""}
                                                                                alt={card_num}

                                                                            />
                                                                        );
                                                                    })}
                                                                </td>
                                                            );
                                                        }
                                                        else if(ele.key === "totalWin"){
                                                            return (
                                                                <td
                                                                    key={ind}
                                                                    style={{ border: "3px solid #ddd", padding: "8px", textAlign: "center" }}
                                                                >
                                                                    {obj.result?.totalWinAmount ?? 0}
                                                                </td>
                                                            );

                                                        }
                                                        else if (ele.key === "handId") {
                                                            return (
                                                                <td
                                                                    key={ind}
                                                                    style={{ border: "3px solid #ddd", padding: "8px", textAlign: "center" }}
                                                                >
                                                                    {obj[ele.key]}
                                                                </td>
                                                            );

                                                        }



                                                        else {
                                                            return (
                                                                <td
                                                                    key={ind}
                                                                    style={{ border: "3px solid #ddd", padding: "8px", textAlign: "center" }}
                                                                >
                                                                    {obj.result[ele.key] ?? 0}
                                                                </td>
                                                            );
                                                        }
                                                    })}
                                                </tr>
                                            ))}
                                        </tbody>


                                    </table>
                                ) :
                                    showDivs.ShowHistory && (
                                        <div id="No_historyrecords" className="norecors_container">
                                            <h1 className="No-records">No History records found.</h1>
                                        </div>
                                    )}



                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
};

export default OptionsMenu;
